{
    "DAYS": "روزها",
    "HOURS": "ساعت‌ها",
    "MINUTES": "دقیقه‌ها",
    "SECONDS": "ثانیه‌ها",
    "STARTING_SOON": "به زودی شروع می‌شود...",
    "EVENT_NOT_STARTED": "این رویداد هنوز شروع نشده است...",
    "DEFAULT_ERROR": "خطای پخش",
    "DEFAULT_ERROR_DESCRIPTION": "امکان پخش ویدیو وجود ندارد. لطفاً بعداً دوباره تلاش کنید.",
    "API_ERROR": "خطا در بازیابی اطلاعات ویدیو",
    "API_ERROR_DESCRIPTION": "خطا در دریافت جزئیات ویدیو. ویدیوId و اتصال اینترنت خود را بررسی کرده و دوباره تلاش کنید.",
    "ERROR_CODE_NOT_AUTHENTICATED": "مجوز",
    "ERROR_CODE_NOT_AUTHENTICATED_DESCRIPTION": "شما اجازه پخش این ویدیو را ندارید.",
    "ERROR_CODE_GEO_BLOCKED": "محدودیت جغرافیایی",
    "ERROR_CODE_GEO_BLOCKED_DESCRIPTION": "متاسفیم، این ویدیو به دلیل محدودیت‌های جغرافیایی در منطقه شما در دسترس نیست.",
    "ERROR_CODE_NOT_ENTITLED": "عدم دسترسی",
    "ERROR_CODE_NOT_ENTITLED_DESCRIPTION": "متاسفیم، شما اجازه پخش این ویدیو را ندارید.",
    "ERROR_CODE_VPN_BLOCKED": "مسدود شدن VPN",
    "ERROR_CODE_VPN_BLOCKED_DESCRIPTION": "این ویدیو به دلیل استفاده از VPN در دسترس نیست.",
    "ERROR_CODE_IP_CHANGED": "تغییر شبکه",
    "ERROR_CODE_IP_CHANGED_DESCRIPTION": "شما به طور غیرمنتظره به شبکه دیگری متصل شده‌اید. لطفاً دوباره تلاش کنید.",
    "ERROR_CODE_VPN_DETECTED": "VPN شناسایی شد",
    "ERROR_CODE_VPN_DETECTED_DESCRIPTION": "ما یک VPN شناسایی کرده‌ایم. لطفاً آن را خاموش کرده و دوباره تلاش کنید.",
    "ERROR_CODE_ANONYMOUS_PROXY": "پروکسی ناشناس شناسایی شد",
    "ERROR_CODE_ANONYMOUS_PROXY_DESCRIPTION": "ما یک پروکسی ناشناس یا سرور شناسایی کرده‌ایم. لطفاً آن را خاموش کرده و دوباره تلاش کنید."
}
